import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Stack,
    Typography
} from "@mui/material";
import {
    BarChartRounded,
    ErrorOutlineRounded,
    InsertChartOutlinedRounded,
    RefreshRounded
} from "@mui/icons-material";

export const LoadStatus = {
    LOADING: 1,
    LOADED: 2,
    NODATA: 3,
    ERROR: 4
};

const BaseReportBox = ({children, title, loadStatus = LoadStatus.NODATA, ReloadData}) => {
    return (
        <Card
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            {/* هدر نمودار */}
            <Box
                sx={{
                    px: { xs: 2.5, sm: 3 },
                    py: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                }}
            >
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: 2.5,
                            bgcolor: 'rgba(28, 139, 156, 0.08)',
                            color: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <BarChartRounded sx={{ fontSize: 20 }} />
                    </Box>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            color: 'text.primary',
                            textAlign: 'right',
                            direction: 'rtl',
                        }}
                    >
                        {title}
                    </Typography>
                </Stack>

                {ReloadData && (
                    <Button
                        size="small"
                        variant="text"
                        onClick={ReloadData}
                        startIcon={<RefreshRounded sx={{ ml: 0.5 }} />}
                        sx={{
                            color: 'text.secondary',
                            fontSize: '0.78rem',
                            fontWeight: 600,
                            borderRadius: 2,
                            py: 0.4,
                            px: 1.2
                        }}
                    >
                        به‌روزرسانی
                    </Button>
                )}
            </Box>

            {/* محتوای نمودار و وضعیت‌ها */}
            <CardContent
                sx={{
                    flexGrow: 1,
                    minHeight: 280,
                    p: { xs: 2, sm: 3 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {loadStatus === LoadStatus.LOADING && (
                    <Stack spacing={1.5} alignItems="center">
                        <CircularProgress size={36} thickness={4} color="primary" />
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                            در حال دریافت و پردازش اطلاعات...
                        </Typography>
                    </Stack>
                )}

                {loadStatus === LoadStatus.LOADED && (
                    <Box sx={{ width: '100%', height: '100%' }}>
                        {children}
                    </Box>
                )}

                {(loadStatus === LoadStatus.NODATA || loadStatus == null) && (
                    <Stack spacing={1.5} alignItems="center" sx={{ py: 3, textAlign: 'center' }}>
                        <Box
                            sx={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                bgcolor: 'action.hover',
                                color: 'text.disabled',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <InsertChartOutlinedRounded sx={{ fontSize: 30 }} />
                        </Box>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                            داده‌های آماری در این بازه کافی نیست
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary', maxWidth: 280, lineHeight: 1.6 }}>
                            با ثبت و پیشرفت خریدهای پرسنل، نمودارهای تحلیلی و روند مصرف در این بخش فعال می‌شوند.
                        </Typography>
                    </Stack>
                )}

                {loadStatus === LoadStatus.ERROR && (
                    <Stack spacing={1.5} alignItems="center" sx={{ py: 3, textAlign: 'center' }}>
                        <Box
                            sx={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                bgcolor: 'rgba(239, 68, 68, 0.1)',
                                color: 'error.main',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <ErrorOutlineRounded sx={{ fontSize: 30 }} />
                        </Box>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                            خطا در دریافت اطلاعات آماری
                        </Typography>
                        {ReloadData && (
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={ReloadData}
                                sx={{ borderRadius: 2, mt: 1, px: 2, fontWeight: 700 }}
                            >
                                تلاش مجدد
                            </Button>
                        )}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
};

export default BaseReportBox;
